import { Row } from "react-grid-system";
import styled from "styled-components";

const LabelGroupWrapper = styled.div`
  /* Base Styling */
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;

export default LabelGroupWrapper;



// WEBPACK FOOTER //
// ./src/screens/Budtender/LabelGroupWrapper.js